// src/components/Logout.js
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logoutUser } from '../redux/authSlice';

const Logout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const performLogout = async () => {
            try {
                await dispatch(logoutUser()).unwrap();
            } catch (error) {
                console.error('Logout error:', error);
            } finally {
                // Always redirect to login, even if API call fails
                navigate('/login', { replace: true });
            }
        };

        performLogout();
    }, [dispatch, navigate]);

    return (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
            <div className="text-center">
                <div className="spinner-border text-primary mb-3" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
                <p className="text-muted">Logging out...</p>
            </div>
        </div>
    );
};

export default Logout;
